import { Route as ngRoute, Routes } from '@angular/router';

import { ShellComponent } from '@bo-client/core/shell/shell.component';
import { ShellExternalComponent } from '@bo-client/core/shell-tm/shell-external.component';

/**
 * Provides helper methods to create routes.
 */
export class Route {
  /**
   * Creates routes using the shell component and authentication.
   * @param routes The routes to add.
   * @return {Route} The new route using shell as the base.
   */
  static withShell(routes: Routes): ngRoute {
    return {
      path: '',
      component: ShellComponent,
      children: routes,
      data: { reuse: false }
    };
  }

  static withShellExternal(routes: Routes): ngRoute {
    return {
      path: '',
      component: ShellExternalComponent,
      children: routes,
      data: { reuse: false }
    };
  }
}
